var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBordercruve3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1005_6966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M781.599 5.46153C769.939 5.46153 760.463 14.9478 760.463 26.5989C760.463 27.9274 759.391 29 758.062 29H25.9477C24.6193 29 23.5468 27.9274 23.5468 26.5989C23.5468 14.9478 14.0611 5.46153 2.40092 5.46153C1.07254 5.46153 0 4.38891 0 3.06045V-497.06C0 -498.389 1.07254 -499.462 2.40092 -499.462C14.0611 -499.462 23.5468 -508.948 23.5468 -520.599C23.5468 -521.927 24.6193 -523 25.9477 -523H758.062C759.391 -523 760.463 -521.927 760.463 -520.599C760.463 -508.948 769.939 -499.462 781.599 -499.462C782.927 -499.462 784 -498.389 784 -497.06V3.06045C784 4.38891 782.927 5.46153 781.599 5.46153ZM779.198 -494.768C766.81 -495.909 756.911 -505.809 755.769 -518.198H28.2404C27.1088 -505.809 17.2099 -495.909 4.81169 -494.768V0.757771C17.2099 1.89927 27.1088 11.7988 28.2404 24.188H755.769C756.911 11.7988 766.81 1.89927 779.198 0.757771V-494.768Z",
    fill: "#C4944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1005_6966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBordercruve3);
export default __webpack_public_path__ + "static/media/bordercruve3.01a19a2d5dbb96f4ec6cf53cccc653bd.svg";
export { ForwardRef as ReactComponent };